var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('puls-navigation-list',{attrs:{"items":_vm.surveysToDisplay,"didSelectItem":_vm.navigateToSurvey},scopedSlots:_vm._u([{key:"details",fn:function(slotProps){return [(slotProps.item.icon)?_c('i',{class:`bi bi-${slotProps.item.icon} fs-3 text-${slotProps.item.variant} me-5`}):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }